var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-loader loader"},[_c('img',{style:({'width': (_vm.width + "px")}),attrs:{"src":require("@/assets/loader.gif"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }